import { typography } from "./typography";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    background: {
      default: "rgb(220, 229, 235)",
      paper: "white",
    },
    primary: {
      contrastText: "#ffffff",
      main: "#171F2A",
    },
    secondary: {
      main: "#c14040",
    },
    text: {
      primary: "#172b4d",
      secondary: "rgb(107, 119, 140)",
    },
  },
  typography,
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "white",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "rgb(44, 72, 93)",
          borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            color: "white",
            backgroundColor: "#333333",
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        markLabel: {
          fontSize: "xx-small",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "7px 7px 7px rgb(34 35 58 / 20%)",
          border: "1px solid #d3d3d3",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "8px",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: "12px",
          paddingRight: "12px",
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: "8px",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          flexWrap: "wrap",
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          paddingBottom: "8px",
        },
      },
    },
  },
});

/** */
